<template>
  <b-modal
    centered
    size="xl"
    id="map-modal"
    class="text-center"
    :title="'Room: ' + room"
    hide-footer
  >
    <img
      class="map"
      :src="'/static/map/' + room + '.jpg'"
      alt=""
      aria-hidden="true"
      style="width: 100%"
    />
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      room: null,
    };
  },
  methods: {
    open(room = "map") {
      this.room = room;
      this.$root.$emit("bv::show::modal", "map-modal");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/modals/MapModal.vue